/**
 * code stolen from
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role
 */
function toggleTabsDisplay(
  target: HTMLButtonElement,
  parent: HTMLDivElement,
  grandparent: HTMLDivElement,
) {
  // Remove all current selected tabs
  parent.querySelectorAll('[aria-selected="true"]').forEach((t: HTMLButtonElement) => {
    t.setAttribute('aria-selected', 'false');
  });

  // Set this tab as selected
  target.setAttribute('aria-selected', 'true');

  // Hide all tab panels
  grandparent.querySelectorAll('[role="tabpanel"]').forEach((p) => {
    p.setAttribute('hidden', 'true');
    p.classList.add('hidden', 'md:hidden');
  });

  // Show the selected panel
  const tabPanelId = target.getAttribute('aria-controls');
  const selectPanel = grandparent.parentNode.querySelector(`#${tabPanelId}`);
  selectPanel.removeAttribute('hidden');
  selectPanel.classList.remove('hidden', 'md:hidden');
}

function changeTabs(e: Event) {
  const target = e.target as HTMLButtonElement;
  const parent = target.parentNode as HTMLDivElement;
  const grandparent = parent.parentNode as HTMLDivElement;

  toggleTabsDisplay(target, parent, grandparent);
}

function Tabs(element: HTMLElement) {
  const buttons = element.querySelectorAll('[role="tab"]');
  const tabList = element.querySelector('[role="tablist"]');

  buttons.forEach((tab, index) => {
    tab.setAttribute('aria-controls', `panel-${index + 1}`);
    tab.addEventListener('click', changeTabs);
  });

  let tabFocus = 0;

  tabList.addEventListener('keydown', (e: KeyboardEvent) => {
    const button = buttons[tabFocus] as HTMLButtonElement;
    // Move right
    if (e.keyCode === 39 || e.keyCode === 37) {
      button.setAttribute('tabindex', '-1');
      if (e.keyCode === 39) {
        tabFocus++;
        // If we're at the end, go to the start
        if (tabFocus >= buttons.length) {
          tabFocus = 0;
        }
        // Move left
      } else if (e.keyCode === 37) {
        tabFocus--;
        // If we're at the start, move to the end
        if (tabFocus < 0) {
          tabFocus = buttons.length - 1;
        }
      }

      button.setAttribute('tabindex', '0');
      button.focus();
    }
  });

  const activeTab = ([...buttons].find(
    (button) => button.getAttribute('aria-selected') === 'true',
  ) ?? buttons[0]) as HTMLButtonElement;
  toggleTabsDisplay(
    activeTab,
    activeTab.parentNode as HTMLDivElement,
    activeTab.parentNode.parentNode as HTMLDivElement,
  );
}

const tabs = {
  init: () => {
    document.querySelectorAll('.js-tabs').forEach((element) => Tabs(element as HTMLElement));
  },
};

export default tabs;
